import { parseISO } from 'date-fns';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import FormDatePicker from '../../components/form_elements/form-date-picker';
import FormDropdown from '../../components/form_elements/form-dropdown';
import FormTextArea from '../../components/form_elements/form-textarea';
import useMsalApi from '../../components/use-msal-api';
import { useMsal } from '@azure/msal-react';

const LifeEventForm = () => {
    const {setValue, trigger} = useFormContext();
    const enrollments = useSelector(s => s.enrollments);
    const [lifeEvents, setLifeEvents] = useState([]);
    const [callApi] = useMsalApi();
    const { accounts } = useMsal();
    const [enrollmentMax, setEnrollmentMax ] = useState();
    const [enrollmentMin, setEnrollmentMin] = useState();

    useEffect(() => {
        if(Array.isArray(enrollments))
            return;
        setValue("effectiveDate", parseISO(enrollments.effectiveDate));
        setValue("lifeEventDescription", enrollments.lifeEventDescription);
    }, [enrollments]);

    useEffect(() => {
        const min = new Date();
        const max = new Date();
        if (accounts[0].idTokenClaims?.roles?.includes("BenefitsAdmin")) {
            setEnrollmentMin(new Date(min.setDate(min.getDate() - 90)).toLocaleDateString());
            setEnrollmentMax(new Date(max.setDate(max.getDate() + 90)).toLocaleDateString());
        } else {
            setEnrollmentMin(new Date(min.setDate(min.getDate() - 30)).toLocaleDateString());
            setEnrollmentMax(new Date(max.setDate(max.getDate() + 30)).toLocaleDateString());
        }
    
        const getLifeEvents = async () => {
            var results = await callApi("lookup/qualifyingEvents", "GET");
            if(!results.error){
                setLifeEvents(results);
                setValue("lifeEventId", enrollments.lifeEventId);
                trigger("lifeEventId");
            }
        }
        getLifeEvents();
    }, [])

    return ( 
        <>
            <div className="my-8">
                <FormDatePicker name="effectiveDate" label="Date of Qualifying Event" minDate={enrollmentMin} maxDate={enrollmentMax} />
            </div>

            <div className="my-8">
                <FormDropdown name="lifeEventId" label="Select a Qualifying Life Event" items={lifeEvents} />
            </div>

            <div className='my-8'>
                <FormTextArea name="lifeEventDescription" label="Describe the Qualifying Life Event" />
            </div>

        </>
     );
}
 
export default LifeEventForm;